<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-06-02 17:42:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-15 17:41:55
-->
<template>
  <div class="videoss">
    <div
      :style="{
        background: datas.backColor,
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <!-- 默认视频 -->
      <section v-if="!datas.videoUrl" class="default">
        <img draggable="false" :src="defaultImg" alt="" class="full_img" />
      </section>

      <!-- 选择视频后 -->
      <section v-else style="position: relative">
        <video
          :src="datas.videoUrl"
          controls
          :loop="datas.loopplay"
          :autoplay="datas.autoplay"
          :poster="datas.coverUrl"
          width="100%"
        />
      </section>
    </div>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
export default {
  name: "Videoss",
  props: {
    datas: Object,
  },
  data() {
    return {
      defaultImg: require("@/assets/images/defaultPic2.png"),
    };
  },
  created() {},

  methods: {},
};
</script>

<style scoped lang="scss">
.videoss {
  position: relative;

  /* 默认视频 */
  .default {
    width: 100%;
    height: 210px;
    background: #979797;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 播放图标 */
  .bof {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 100px;
    opacity: 0.5;
    color: #999;
  }
}
</style>
